<template>
    <div class="form-group" :class="{'has-error': error}">
        <label :for="_uid" class="form__label">
            {{label}}<small v-if="labelSuffix"> ({{labelSuffix}})</small> <span class="required" v-if="showRequiredStar">*</span>
        </label>
        <input :type="type" ref="text" @focus="$emit('focus', $event)" :id="_uid" v-model="internalValue" class="form__input form__input--text" :placeholder="placeholder" :disabled="disabled" @blur="$emit('blur')" />
        <span class="form__error" v-if="error">{{error}}</span>
    </div>
</template>

<script>

export default {
    name: "GlobalInputField",
    components: {},
    props: {
        autofocus: {
            type: Boolean,
            default: false,
        },
        label: {
            type: String,
            default: 'No label provided',
            required: true
        },
        labelSuffix: {
            type: String,
            default: '',
            required: false
        },
        type: {
            type: String,
            default: 'text',
            required: false
        },
        value: {
            type: String,
            default: ''
        },
        error: {
            type: String
        },
        disabled: {
            type: Boolean,
            default: false
        },
        rows: {
            type: Number,
            default: 3
        },
        placeholder: {
            type: String,
            default: '',
            required: false
        },
        showRequiredStar: false
    },
    data() {
        return {
            internalValue: this.value
        }
    },
    watch: {
        value: function(newValue) {
            if (this.internalValue !== newValue) {
                this.internalValue = newValue;
            }
        },
        internalValue: function(newValue) {
            this.$emit('input', newValue);
        }
    },
    computed: {
    },
    methods: {
    },
    mounted() {
        this.$nextTick(() => this.$refs.text.focus())
    }
}
</script>
